export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.pageStructureInSetting = payload;

  return newState;
};
